module.exports = __webpack_public_path__ + "media/images/icons/icon-chart-growth-9afa1f1c890c669bfd5c4a08daa60885.svg";